import { type IUser } from 'entities/Users'

export const parseNoteBody = (body: string, users: Map<number, IUser>) => {
  body = body.replaceAll(/\{tag:(\S+)\}/g, (value, data) => {
    const [type, id] = data.split(':')
    const user = users.get(Number(id))

    if (type === 'inbox') {
      return '<a class="mention" href="#">@inbox</a>'
    }

    return `<a class="mention" href="#">@${user?.full_name || ''}</a>`
  })

  return body
}

export const parseMentionsTemplate = (body: string, users: Map<number, IUser>) => {
  body = body.replaceAll('@inbox', '{tag:inbox}')

  const validUsers = Array.from(users.values())
    .filter((user) => user.full_name && user.full_name.trim() !== '')
    .sort((a, b) => b.full_name!.length - a.full_name!.length)

  validUsers.forEach((user) => {
    body = body.replaceAll(`@${user.full_name}`, `{tag:user:${user.id}}`)
  })

  return body
}
